import { z } from "zod";
import { customErrorMap } from "../shared/validation/zod";
import { DocumentSettingsSchema } from "./document-settings";
import { documentStatusSchema } from "./types";


z.setErrorMap(customErrorMap);


export const EntryDocumentSchema = z.object({

    // required
    id: z.number(),
    business_id: z.number(),
    account_id: z.number(),
    document_settings_id: z.number(),

    created_at: z.string().optional(),
    updated_at: z.string().optional(),


    document_number: z.number(),
    date_time: z.string(),
    status: documentStatusSchema,
    


    // nullable
    works_total: z.coerce.number().nullable(),
    items_total: z.coerce.number().nullable(),
    discount: z.coerce.number().nullable(),
    total: z.coerce.number().nullable(),
    vat: z.coerce.number().nullable(),
    to_pay: z.coerce.number().nullable(),
    balance: z.coerce.number().nullable(),
    reference: z.string().nullable(),

    
    // loads
    document_settings: DocumentSettingsSchema.optional(),

});
